import Archive from "lucide-react/dist/esm/icons/archive.mjs";
import BookmarkPlus from "lucide-react/dist/esm/icons/bookmark-plus.mjs";
import BookOpenText from "lucide-react/dist/esm/icons/book-open-text.mjs";
import Settings from "lucide-react/dist/esm/icons/settings.mjs";
import Star from "lucide-react/dist/esm/icons/star.mjs";
import Library from "lucide-react/dist/esm/icons/library.mjs";
import type { LibrarySection } from "../types";
import { Brand } from "./Brand";

const sections: Array<{ id: LibrarySection; label: string; icon: typeof BookOpenText }> = [
  { id: "library", label: "Library", icon: Library },
  { id: "starred", label: "Starred", icon: Star },
  { id: "archive", label: "Archive", icon: Archive },
];

export function NavigationRail({
  active,
  counts,
  online,
  onSelect,
  onSave,
  onSettings,
}: {
  active: LibrarySection | "search";
  counts: Partial<Record<LibrarySection, number>>;
  online: boolean;
  onSelect: (section: LibrarySection) => void;
  onSave: () => void;
  onSettings: () => void;
}) {
  return (
    <aside className="navigation-rail" aria-label="Imprint library">
      <Brand />
      <nav className="navigation-rail__nav">
        <p className="navigation-rail__label">Library</p>
        {sections.slice(0, 3).map((item) => (
          <RailButton key={item.id} item={item} active={active === item.id} count={counts[item.id]} onSelect={onSelect} />
        ))}
      </nav>
      <div className="navigation-rail__footer">
        <button type="button" disabled={!online} title={online ? undefined : "Available online"} onClick={onSave}><BookmarkPlus aria-hidden="true" /><span className="navigation-rail__footer-label">Save a page</span></button>
        <button type="button" onClick={onSettings}>
          <Settings aria-hidden="true" /><span className="navigation-rail__footer-label">Settings</span>
          <span className={`connection-dot${online ? "" : " connection-dot--offline"}`} aria-label={online ? "Online" : "Offline"} />
        </button>
      </div>
    </aside>
  );
}

function RailButton({
  item,
  active,
  count,
  onSelect,
}: {
  item: (typeof sections)[number];
  active: boolean;
  count?: number;
  onSelect: (section: LibrarySection) => void;
}) {
  const Icon = item.icon;
  return (
    <button className={`rail-button${active ? " rail-button--active" : ""}`} type="button" onClick={() => onSelect(item.id)} aria-current={active ? "page" : undefined}>
      <Icon aria-hidden="true" />
      <span>{item.label}</span>
      {typeof count === "number" ? <span className="rail-button__count">{count}</span> : null}
    </button>
  );
}
